var map = {
	"./air-nga-en/assets/results-nav-icon-active.png": 12943,
	"./ais-tai-en/assets/results-nav-icon-active.png": 698,
	"./ais-tai-tha/assets/results-nav-icon-active.png": 94758,
	"./demo-arabic/assets/results-nav-icon-active.png": 39262,
	"./demo-et-en/assets/results-nav-icon-active.png": 94883,
	"./demo-romanian/assets/results-nav-icon-active.png": 15729,
	"./demo-um-en/assets/results-nav-icon-active.png": 20638,
	"./dtac-tai-en/assets/results-nav-icon-active.png": 42385,
	"./dtac-tai-tha/assets/results-nav-icon-active.png": 55015,
	"./ethiotel-et-amh/assets/results-nav-icon-active.png": 31373,
	"./ethiotel-et-en/assets/results-nav-icon-active.png": 98812,
	"./mtn-cg-fr/assets/results-nav-icon-active.png": 5877,
	"./mtn-ci-fr/assets/results-nav-icon-active.png": 48023,
	"./mtn-cmr-fr/assets/results-nav-icon-active.png": 51019,
	"./mtn-gha-en/assets/results-nav-icon-active.png": 27652,
	"./mtn-nga-en/assets/results-nav-icon-active.png": 12856,
	"./mtn-zam-en/assets/results-nav-icon-active.png": 510,
	"./saf-ke-en/assets/results-nav-icon-active.png": 15483,
	"./saudi-uae-en/assets/results-nav-icon-active.png": 55598,
	"./tlk-za-en/assets/results-nav-icon-active.png": 25359,
	"./vc-za-en/assets/results-nav-icon-active.png": 1451
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3461;